import { Label, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@playcastdotio/Shadcn';
import { useState } from 'react';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const getHours = (scheduleType: string, day: string) => {
  switch (scheduleType) {
    case 'Full':
      return '24/7';
    case 'Peak Only':
      if (day === 'Sun' || day === 'Sat') return '2pm - 10pm';
      return '11am - 2pm, 6pm - 10pm';
    case 'Opt-Out':
      return <span className='text-gray-400'>—</span>;
    default:
      return null;
  }
};

export const CafeSchedule = () => {
  const [scheduleType, setScheduleType] = useState('Full');

  return (
    <div data-testid='content-root' className='flex flex-1 flex-col gap-4 text-white'>
      <Label className='font-[Syne] text-3xl'>Café Schedule</Label>
      <div data-testid='content-children-container' className='flex h-full w-full flex-col gap-4'>
        <div className='flex items-center justify-between gap-4'>
          <Label className='flex-none font-[Syne] text-xl'>Schedule Type</Label>
          <Select value={scheduleType} onValueChange={(value) => setScheduleType(value)}>
            <SelectTrigger>
              <SelectValue placeholder='Select Schedule Type' />
            </SelectTrigger>
            <SelectContent className='z-[99999]'>
              <SelectItem value='Full'>Full</SelectItem>
              <SelectItem value='Peak Only'>Peak Only</SelectItem>
              <SelectItem value='Opt-Out'>Opt-Out</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className='flex flex-col gap-2'>
          <Label className='mb-2 font-[Syne] text-xl'>Hours Schedule:</Label>
          <div className='overflow-hidden rounded-lg border border-white'>
            <table className='w-full overflow-hidden text-white'>
              <thead>
                <tr className='bg-gray-800'>
                  <th className='px-4 py-2 text-left font-semibold'>Day</th>
                  <th className='px-4 py-2 text-left font-semibold'>Hours</th>
                </tr>
              </thead>
              <tbody>
                {DAYS.map((day) => (
                  <tr key={day} className='border-t border-white'>
                    <td className='w-36 px-4 py-2'>{day}</td>
                    <td className='px-4 py-2'>{getHours(scheduleType, day)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
